import { DdSites, DdOcdeRr, DdOcdeAe, DdOcdeCap, DdPolicyTracker, DdOcdeDd6 } from "../../api";
import { FALLBACK_SITES } from "../../hooks/useDdSites";
import { RISKS, RR_DEFAULT, buildDefaultScoringForSite, migrateRrData } from "../../pages/admin/OcdeRiskRegister/ocdeRrCatalog";
import { DIMENSIONS, AE_DEFAULT } from "../../pages/admin/SelfAssessments/ocdeAeCatalog";
import { CAP_DEFAULT } from "../../pages/admin/OcdeCap/ocdeCapCatalog";
import { trBuildDefault, trMergeWithDefaults } from "../../pages/admin/PolicyTracker/policyTrackerCatalog";
import { dd6Normalize } from "../../pages/admin/OcdeDdProcess/ocdeDd6Catalog";

const clone = (x) => JSON.parse(JSON.stringify(x));

/**
 * Datos del informe DD a partir de lo guardado en la API, completados igual que
 * en cada módulo: valores de demostración si no hay nada guardado y una entrada
 * por defecto para cada riesgo/área × sede que falte. Así el informe muestra lo
 * mismo que el usuario ve en pantalla.
 */
export function prepareDdReportData({ sites, rr, ae, cap, tr, dd6 }) {
  const siteList = (Array.isArray(sites) && sites.length ? sites : FALLBACK_SITES)
    .map((s) => ({ ...s, headcount: Number(s.headcount) || 0 }));

  const rrData = rr ? migrateRrData(rr).data : { scoring: clone(RR_DEFAULT), status: {} };
  const rrScoring = {};
  RISKS.forEach((r) => {
    rrScoring[r.id] = {};
    siteList.forEach((s) => { rrScoring[r.id][s.id] = rrData.scoring?.[r.id]?.[s.id] || buildDefaultScoringForSite(r.id); });
  });
  const rrStatus = Object.fromEntries(RISKS.map((r) => [r.id, rrData.status?.[r.id] || "pending"]));

  const maturity = ae?.maturity || clone(AE_DEFAULT);
  const aeMaturity = {};
  DIMENSIONS.forEach((d) => {
    aeMaturity[d.id] = {};
    siteList.forEach((s) => { aeMaturity[d.id][s.id] = maturity[d.id]?.[s.id] || { level: 1, notes: "" }; });
  });

  return {
    sites: siteList,
    rrScoring,
    rrStatus,
    aeMaturity,
    caps: Array.isArray(cap?.caps) ? cap.caps : clone(CAP_DEFAULT),
    tracker: tr ? trMergeWithDefaults(tr) : trBuildDefault(),
    dd6: dd6Normalize(dd6?.data),
  };
}

const apis = {
  sites: new DdSites(), rr: new DdOcdeRr(), ae: new DdOcdeAe(),
  cap: new DdOcdeCap(), tr: new DdPolicyTracker(), dd6: new DdOcdeDd6(),
};

/**
 * Carga en paralelo los 6 módulos OCDE de la empresa y los prepara para el informe.
 * Si una carga falla se propaga el error: rellenar con la demo daría un informe con datos falsos.
 */
export async function loadDdReportData(accessToken) {
  const keys = Object.keys(apis);
  const values = await Promise.all(keys.map((k) => apis[k].getData(accessToken)));
  return prepareDdReportData(Object.fromEntries(keys.map((k, i) => [k, values[i]])));
}
